import { PCFSoftShadowMap, sRGBEncoding, WebGLRenderer, WebGLRendererParameters } from 'three'
import * as THREE from 'three'
import { useEffect, useState } from 'react'
import { useAppStore } from '../../shared/store/store'

const rendererParameters: WebGLRendererParameters = {
  powerPreference: 'high-performance',
  antialias: false,
  stencil: false,
  depth: false,
  alpha: true,
}

export function useRenderer() {
  const [renderer, setRenderer] = useState<WebGLRenderer | undefined>(undefined)
  const width = useAppStore((state) => state.width)
  const height = useAppStore((state) => state.height)

  useEffect(() => {
    if (width === 0 || height === 0) return
    let _renderer = renderer
    if (!_renderer) {
      _renderer = new THREE.WebGLRenderer(rendererParameters)
      _renderer.shadowMap.enabled = true
      _renderer.shadowMap.type = PCFSoftShadowMap
      _renderer.outputEncoding = sRGBEncoding
      _renderer.toneMapping = THREE.ACESFilmicToneMapping
      _renderer.toneMappingExposure = THREE.ReinhardToneMapping
      _renderer.debug.checkShaderErrors = false
      const devicePixelRatio = window.devicePixelRatio
      _renderer.setPixelRatio(devicePixelRatio)
      setRenderer(_renderer)
    }
    _renderer.setSize(width, height)
  }, [width, height])

  return renderer
}
